export const routesRules = {
  computed: {
    isShopPage() {
      return ['shop', 'skill-dive', 'boogo', 'black-friday', 'leap-year-2024'].includes(
        this.$route.name
      )
    },
    isHeaderShown() {
      return ![
        'shop',
        'complete',
        'skill-dive',
        'boogo',
        'black-friday',
        'leap-year-2024',
      ].includes(this.$route.name)
    },
    routeName() {
      return this.$route.name
    },
    showHeroSection() {
      const showShopHeroIn = [
        'shop',
        'premium-monthly',
        'eeda-presale',
        'ecppt-presale',
        'skill-dive',
        'boogo',
        'black-friday',
        'leap-year-2024',
      ]
      return showShopHeroIn.includes(this.$route.name)
    },
    showHeaderBackBtn() {
      return ['skill-dive', 'boogo', 'black-friday', 'leap-year-2024'].includes(this.$route.name)
    },
    showShopFooter() {
      const showShopFooterIn = ['premium-monthly', 'eeda-presale', 'skill-dive', 'leap-year-2024']
      return this.isShopPage || showShopFooterIn.includes(this.$route.name)
    },
    isCartFlowPage() {
      return ['payment', 'confirmation'].includes(this.$route.name)
    },
    showSignOutLink() {
      return !['free-trial', 'premium-monthly', 'eeda-presale'].includes(this.$route.name)
    },
    isBlackFridayPage() {
      return this.$route.name === 'black-friday'
    },
    isLeapYearPromoPage() {
      return this.$route.name === 'leap-year-2024'
    },
    isEDAPremiumPage() {
      return this.$route.name === 'eeda-presale'
    },
    isAccountPage() {
      return this.$route.name === 'account'
    },
    isBooGoPage() {
      return this.$route.name === 'boogo'
    },
    isPremiumMonthlyPromoPage() {
      return this.$route.name === 'premium-monthly'
    },
    isCompletePage() {
      return this.$route.name === 'complete'
    },
    isConfirmationPage() {
      return this.$route.name === 'confirmation'
    },
  },
}
